import { createContext, useContext, useEffect, useState } from "react";
import { fetchSite } from "@/lib/api";

const SiteContext = createContext({ settings: {}, content: {}, rooms: [], meeting_rooms: [], faqs: [], gallery: [], loading: true });

export function SiteProvider({ children }) {
  const [data, setData] = useState({ settings: {}, content: {}, rooms: [], meeting_rooms: [], faqs: [], gallery: [], loading: true });

  useEffect(() => {
    fetchSite()
      .then((d) => setData({ ...d, loading: false }))
      .catch(() => setData((s) => ({ ...s, loading: false })));
  }, []);

  return <SiteContext.Provider value={data}>{children}</SiteContext.Provider>;
}

export function useSite() {
  return useContext(SiteContext);
}

/** CMS content getter: c("hero_title") -> localized string */
export function useContent() {
  const { content } = useSite();
  return (key, lang, fallback = "") => (content[key] && (content[key][lang] || content[key].es)) || fallback;
}
